import { Dispatch } from "redux";

import * as Sentry from "@sentry/browser";

import { makeRequest } from "../util";
import {
  AccountMetadata,
  SET_ACCOUNT_METADATA,
  SET_CURRENT_ENVIRONMENT,
} from "../reducers/environments";

export const fetchAccountMetadata = () => {
  return async (dispatch: Dispatch) => {
    return makeRequest<AccountMetadata>("account_metadata", {})
      .then((response) => {
        dispatch({ type: SET_ACCOUNT_METADATA, payload: response.data });
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  };
};

export const setCurrentEnvironment = (envID: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SET_CURRENT_ENVIRONMENT, payload: envID });
  };
};
